import { render } from "./forgotpassword.vue?vue&type=template&id=587c3d21&scoped=true"
import script from "./forgotpassword.vue?vue&type=script&lang=js"
export * from "./forgotpassword.vue?vue&type=script&lang=js"

import "./forgotpassword.vue?vue&type=style&index=0&id=587c3d21&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-587c3d21"]])

export default __exports__